<template>
  <div class="nsalePage_">
    <div class="title_">邀请注册</div>
    <div class="content_">
      <div class="input_">
        <div class="text_">用户名称:</div>
        <cube-input
          class="logStyle"
          v-model="form.name"
          placeholder="请输入用户名称"
        ></cube-input>
      </div>
      <div class="input_ tip_">
        <div class="text_">登录账号：</div>
        <span v-if="validateType == 'Y'" class="send_" @click="sendPrompt"
          >发送验证码</span
        >
        <cube-input
          v-if="validateType == 'Y'"
          class="logStyle"
          v-model="form.loginName"
          placeholder="请输入手机号"
        >
        </cube-input>
        <cube-input
          v-else
          class="logStyle"
          v-model="form.loginName"
          placeholder="请输入登录账号"
        ></cube-input>
      </div>
      <div class="input_">
        <div class="text_">联系人：</div>
        <cube-input
          class="logStyle"
          v-model="form.linkman"
          placeholder="请输入联系人"
        ></cube-input>
      </div>
      <div class="input_">
        <div class="text_">电子邮箱：</div>
        <cube-input
          class="logStyle"
          v-model="form.contactInformation"
          placeholder="请输入电子邮箱"
        ></cube-input>
      </div>
      <div class="input_">
        <div class="text_">手机号码：</div>
        <cube-input
          type="phone"
          class="logStyle"
          v-model="form.phone"
          placeholder="请输入手机号码"
        ></cube-input>
      </div>
      <div class="input_">
        <div class="text_">初始密码：</div>
        <cube-input
          type="password"
          class="logStyle"
          v-model="form.password"
          placeholder="请输入初始密码"
        ></cube-input>
      </div>
    </div>
    <div>
      <img
        src="../../assets/image/nsale/checkbox.png"
        alt=""
        style="vertical-align: middle;"
        @click="goPage"
      />
      <span @click="goPage">已阅读并同意</span>
      <router-link to="/nsale/pdfView"
        ><a href="javascript:;" style="color: #4375FF;"
          >注册协议</a
        ></router-link
      >
      和
      <router-link to="/bs/privacyAgreement"
        ><a href="javascript:;" style="color: #4375FF;"
          >隐私协议</a
        ></router-link
      >
      相关内容
    </div>
    <div class="btn_wrap_">
      <cube-button class="Btn" @click="submit">保存</cube-button>
    </div>
    <div class="head_">
      <div class="head_m">
        <img
          v-if="userInfo.imageUrl != '' && userInfo.imageUrl != null"
          class="h_img"
          :src="userInfo.imageUrl"
          alt="head"
        />
        <img
          v-else
          class="h_img"
          src="http://image.run4wd.com/newBee/userAvatar.png"
          alt="null"
        />
      </div>
      <div>您的注册邀请人：{{ userInfo.referrer }}</div>
    </div>
    <!-- v-if="visible" -->
    <div class="outer_" v-if="visible">
      <div></div>
      <div class="inner_">
        <div class="title">已向您输入的手机号码发送短信验证码，请注意查收</div>
        <div style="padding:10px;">
          <div class="body_">
            <cube-input
              class="codeInput"
              v-model="phoneCode"
              placeholder="请输入验证码"
            ></cube-input>
            <span
              v-show="!sendAuthCode"
              class="auth_text auth_text_blue"
              :style="{ cursor: 'pointer' }"
              @click="userSendMessage"
              >重新发送</span
            >
            <span v-show="sendAuthCode" class="auth_text">
              <span class="auth_text_blue">{{ auth_time }} </span>
              秒</span
            >
          </div>
          <div class="btn_list">
            <div class="btn_" @click="hideOut">取消</div>
            <div class="btn_ btn_1" @click="checkCode">确定</div>
          </div>
        </div>
      </div>
    </div>

    <cube-popup ref="extendPopup">
      <div class="popup_mask">
        <span>{{ modelText }}</span>
      </div>
    </cube-popup>

    <!-- 协议签署提示弹窗 -->
    <cube-popup :visible="showAgreementPop">
      <div class="agreement-popup_box">
        <h4>您已注册成功！</h4>
        <p class="agreement-tips">
          {{
            cporpa === "1"
              ? "为保证业务行为合法、公正、顺利进行，现保思用户需要签署《蝶系合作协议》，请联系您的首层渠道进行协议签署"
              : "点击按钮进行蝶系合作协议签署"
          }}
        </p>
        <div class="agreement-btn_box">
          <cube-button class="btn_ sign_" @click="goSign"
            >去签署协议</cube-button
          >
        </div>
      </div>
    </cube-popup>
  </div>
</template>

<script>
import api from "@/utils/api";
import apiNsale from "@/utils/nsaleApi.js";
import moment from "moment";
export default {
  data() {
    document.title = "邀请注册";
    return {
      modelText: "",
      linkurl: "",
      identify: "",
      validateType: "N",
      isBSApp: "", //确认是否是保司
      appId: "", //确认是否是保司
      visible: false,
      sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      auth_time: 0 /*倒计时 计数器*/,
      phoneCode: "", //验证码
      auth_timetimer: null,
      loginValidate: false, //校验是否通过
      userInfo: {
        imageUrl: "",
        referrer: ""
      },
      form: {
        name: "",
        loginName: "",
        linkman: "",
        contactInformation: "",
        phone: "",
        password: "",
        teamTemplateId: "",
        accountType: 1
        // netFeeType: "",
        // settleType: "",
      },
      formDefault: {
        idTypeTxt: "身份证",
        sexTxt: "请选择",
        birthDateTxt: "请选择",
        bankProvinceCodeTxt: "请选择",
        bankCityCodeTxt: "请选择",
        bankHeadCodeTxt: "请选择"
      },
      registerUserId: "", // 注册成功后的用户id
      showAgreementPop: false, // 协议签署提示弹窗
      hasAgreementRoot: true, // cporpa ==1 的时候展示签署协议
    };
  },
  mounted() {
    startScreen()
    this.getAppId();
    this.showOptionMenu();
    // this.identify = localStorage.getItem('i_')  //配置微信分享所需参数
    this.userId = this.$route.query.userId;
    console.log(this.$route.query)
    console.log(this.userInfo.imageUrl, "---->img");
    const { id } = this.$route.params;
    const { token } = this.$route.query;
    this._token = token || "1";
    this.form.teamTemplateId = id;
    this.getWbuserExtByRegistLink();
  },
  beforeDestroy() {
    try {
      WeixinJSBridge.call("hideOptionMenu");
    } catch (error) {}
  },
  methods: {
    moment,
    // 去协议页面
    goPage() {
      this.$router.push({
        path: "/nsale/pdfView"
      });
    },
    // 禁止投保规则调用
    checkInvite() {
      const ruleCode = "202205278,20220805348"; // 生产
      // const ruleCode = "20220519913,20220812919"; // 测试
      const params = {
        cuswebuserid: this.userInfo.id,
        operate: "禁止-邀请下级",
        ruleCode
      };
      apiNsale.verifyState(params).then(res => {
        let { returnCode, data } = res.data;
        if (returnCode === "0000" && data == "1") {
          // 状态为1禁止邀新
          this.modelText = "注册失败，邀请人状态异常";
          this.$refs.extendPopup.show();
        }
      });
    },
    getAppId() {
      this.appId = localStorage.getItem("a_id");
    },
    verifyBSAppId() {
      //接口判断appid
      api.verifyBSAppId().then(res => {
        this.isBSApp = res.data.content;
      });
    },
    showOptionMenu() {
      try {
        WeixinJSBridge.call("showOptionMenu");
      } catch (error) {}
    },
    judgeUrl() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let url = "";
      if (isAndroid) {
        url = location.href;
      }
      if (isIOS) {
        url = location.href.split("#")[0]; //hash后面的部分如果带上ios中config会不对
      }
    },
    fetchJsSdkSign() {
      // const url = encodeURIComponent(location.href.split("#")[0]);
      let url = location.href.split("#")[0];
      // alert(url)
      this.linkurl = url;
      let _this = this;
      console.log(url, "href==");
      // alert('获取签名url ->' + url)
      api
        .getJsJdkSign2({
          url: url,
          userId: this.userInfo.id
        })
        .then(res => res.data)
        .then(async data => {
          const { appId, jssdkReqData } = data;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options);
          let opstion = {
            title: "邀请注册", // 分享标题
            link: window.location.href,
            imgUrl: "http://provider.medilink-global.com.cn/m/img/himg.png", // 分享图标
            desc: "交易、工具、团队，做保险用保思，人人都是BOSS",
            success: function() {
              console.log("success++");
            },
            error: function() {
              console.log("failed++");
            }
          };
          if (_this.appId != "wx6caf1ccf0fe9a167") {
            //路径获取appid
            opstion.desc = " 青春还在，梦想别等待，加入我们成就梦想。";
          }
          wxShare(opstion);
        });
    },
    handleEvent(event) {
      //阻止drawer冒泡
      event.stopPropagation();
    },
    hideOut() {
      this.visible = false;
    },
    sendPrompt() {
      console.log(1);
      this.checkRepeat();
    },
    productNeedCheck() {
      api
        .productNeedCheck({ userId: "Y@" + this.userInfo.id })
        .then(res => {
          this.validateType = res.data.content;
        })
        .catch(err => {
          this.modelText = "注册失败，邀请人状态异常";
          this.$refs.extendPopup.show();
        });
    },
    checkRepeat() {
      if (this.validateType == "Y" && !this.form.loginName) {
        this.toast("请输入登录账号");
        return;
      }

      if (this.validateType == "Y" && !/1\d{10}/.test(this.form.loginName)) {
        this.toast("请输入正确手机号");
      } else if (
        this.validateType == "Y" &&
        /1\d{10}/.test(this.form.loginName)
      ) {
        api.checkRepeat({ userName: this.form.loginName }).then(res => {
          if (res.data.content == "Y") {
            this.toast("手机号已存在");
          } else {
            this.userSendMessage(); //发送验证码
          }
        });
      }
    },
    userSendMessage() {
      let val = this.form.loginName;
      api.userSendMessage({ phone: val }).then(res => {
        // 短信服务宕机下临时处理
          let data = res.data;
          const dataAll = Object.assign(data.content || {},data.data || {});
          if(dataAll && dataAll.defaultFlag && dataAll.defaultFlag == 'Y') {
            this.phoneCode = dataAll.verificationCode
          }
        this.sendAuthCode = true;
        this.getAuthCode();
        this.visible = true;
      });
    },
    checkCode() {
      let phoneN = this.form.loginName;
      let data = {
        phone: phoneN,
        code: this.phoneCode
      };
      console.log(11);
      if (this.phoneCode == "") {
        this.toast("请输入验证码");
      } else {
        api.checkCode(data).then(res => {
          if (res.data.returnCode == "0000") {
            this.toast("校验通过");
            this.visible = false;
            this.form.phone = phoneN;
            this.loginValidate = true;
          } else {
            this.loginValidate = false;
          }
        });
      }
    },
    getAuthCode() {
      clearInterval(this.auth_timetimer);
      this.auth_time = 120;
      this.auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = false;
          clearInterval(this.auth_timetimer);
        }
      }, 1000);
    },
    getWbuserExtByRegistLink() {
      //查询邀请注册页面的头像和注册邀请人
      let params = {
        registerUrl: window.location.href
      };
      api.getWbuserExtByRegistLink(params).then(res => {
        //SAAS-819 账号注销-蝶
        // ① 注销后原先的海报失效
        this.userInfo = res.data.content;
        if (this.userInfo.channelSystem === "1") {
          if (
            this.userInfo.status === "1" &&
            this.userInfo.deleteFlag === "1"
          ) {
            this.modelText = "链接已失效";
            this.$refs.extendPopup.show();
          }
        }
        // 获取邀请人的账号类型
        this.getCporpa();
        this.productNeedCheck();
        this.checkInvite();
        this.fetchJsSdkSign();
      });
    },
    checkInput(val, key) {
      switch (key) {
        case "name":
          if (val == "") {
            return {
              valid: false,
              title: "请输入用户名"
            };
          }
          break;
        case "loginName":
          if (!/[\da-zA-Z]/.test(val) && this.validateType == "N") {
            return {
              valid: false,
              title: "登录账号仅限使用英文字母或数字"
            };
          } else if (this.validateType == "Y" && !/1\d{10}/.test(val)) {
            return {
              valid: false,
              title: "登录账号请输入正确的手机号"
            };
          }
          break;
        case "linkman":
          if (!/[a-zA-Z0-9\u4E00-\u9FA5]/g.test(val)) {
            return {
              valid: false,
              title: "联系人仅限使用英文字母或数字或汉字"
            };
          }
          break;
        case "contactInformation":
          if (!(/\@\w+\./.test(val) || /1\d{10}/.test(val))) {
            return {
              valid: false,
              title: "请输入可联系的邮箱"
            };
          }
          break;
        case "phone":
          if (!/1\d{10}/.test(val)) {
            return {
              valid: false,
              title: "请输入正确的手机号"
            };
          }
          break;
        case "password":
          if (!/[\da-zA-Z]{6,10}/.test(val)) {
            return {
              valid: false,
              title: "密码请设置6-10位英文字母或数字"
            };
          }
          break;
      }
    },
    toast(title) {
      const toast = this.$createToast({
        txt: title,
        type: "txt"
      });
      toast.show();
      let st = setTimeout(() => {
        toast.hide();
        clearTimeout(st);
      }, 2000);
    },
    submit() {
      let href = window.location.href;
      let arr = href.split("/");
      let params = arr[arr.length - 1];
      let canSubmit = true;
      for (let key in this.form) {
        const result = this.checkInput(this.form[key], key);
        console.log("submit -> checkInput", result);
        if (result && !result.valid) {
          canSubmit = false;
          this.toast(result.title);
          break;
        }
      }
      if (canSubmit) {
        this.form.params = this.form.teamTemplateId;
        if (!this.loginValidate && this.validateType == "Y") {
          this.toast("该登录账号未通过手机号短信验证");
        } else {
          api
            .submitNSaleUser(this.form, {
              headers: { token: this._token }
            })
            .then(res => {
              const { returnCode, returnMsg, content } = res.data;
              if (returnCode === "00") {
                this.registerUserId = content;
                // 如果是个人，则跳转至协议签订页面
                if ((this.cporpa === "1" && !this.hasAgreementRoot) || (this.cporpa === "2")) {
                  this.showAgreementPop = true;
                } else {
                  this.toast("您已注册成功！");
                }
                this.saveUserScreenRecord(content)
                this.resetForm();
              } else {
                this.toast(returnMsg);
              }
            });
        }
      }
    },
    // 保存用户注册录屏
    saveUserScreenRecord(cuswebuserid) {
      api.saveUserScreenRecord({
        cuswebuserid,
        msgId: sessionStorage.getItem('clairvoyance_message_id'),
        sourceType: '2',
        screenType: '2'
      })
      setTimeout(() => {
        console.log(clairvoyanceRecord, 'clairvoyanceRecord')
        // 结束录屏
        if (clairvoyanceRecord) {
          clairvoyanceRecord.save();
          clairvoyanceRecord.finish({
            notStopRecord: false,
          });
        }
      })
    },
    // 跳转协议签署相关页面
    goSign() {
      let name = this.cporpa === "1" ? "agreementNotices" : "agreementList";
      this.$router.push({
        name,
        query: { userId: this.registerUserId, isOld: false }
      });
    },
    resetForm() {
      this.form = {
        name: "",
        loginName: "",
        linkman: "",
        contactInformation: "",
        phone: "",
        password: "",
        teamTemplateId: "",
        accountType: 1
        // netFeeType: "",
        // settleType: "",
      };
      this.phoneCode = "";
      this.loginValidate = false;
      this.sendAuthCode = true;
    },
    // 查询分享注册的用户类型（企业/个人）
    getCporpa() {
      api.checkWithdrawalPermission(this.userInfo.id).then(res => {
        const data = res.data;
        if (data.returnCode == "0000") {
          if (data.content) {
            this.cporpa = data.content.cporpa;
            this.hasAgreementRoot = data.content.hasAgreementRoot;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.nsalePage_ {
  .head_ {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
    .head_m {
      margin: 0 10px;
      height: 60px;
      width: 60px;
      border-radius: 50%;
    }
    .h_img {
      height: 60px;
      width: 60px;
      border-radius: 50%;
    }
  }
  // padding: 15px;
  min-height: 100vh;
  background: #f3f4f6;
  font-size: 15px;
  .title_ {
    line-height: 44px;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    background: #fff;
  }
  .content_ {
    margin: 15px;
    padding: 0 25px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    .input_ {
      width: 305px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f0f0f0;
      padding: 5px 0;

      .text_ {
        color: rgba(51, 51, 51, 1);
        width: 100px;
        text-align: left;
        height: 40px;
        line-height: 40px;
      }
      .text_1 {
        font-size: 13px;
        color: rgba(20, 35, 75, 1);
        margin: 0 10px;
        height: 40px;
        line-height: 40px;
      }
      .img_ {
        height: 13px;
        width: auto;
      }
      .logStyle {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(204, 204, 204, 1);
        height: 36px;
        border-radius: 18px;
        background: none;
        display: flex;
      }
      .input_c {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    }
  }
  .btn_wrap_ {
    margin: 15px;
  }
  .Btn {
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    height: 45px;
    background: #017ceb;
    border-radius: 5px;
  }
}
.cube-input::after {
  border: none;
}

.arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #14234b;
}
.outer_ {
  position: fixed;
  z-index: 10001;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .inner_ {
    border-radius: 6px;
    background: #fff;
    // padding: 20px 20px 0 20px;
    width: 90%;
    // height: 130px;
    .body_ {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
      .codeInput {
        width: 200px;
        border: 1px solid #cccccc;
        height: 30px;
      }
    }
    .title {
      font-weight: bold;
      font-size: 14px;
      margin: 10px 0;
    }
    .btn_list {
      display: flex;
      margin: 20px 20px 0px;
    }
    .btn_ {
      color: #017ceb;
      font-size: 15px;
      height: 30px;
      line-height: 30px;
      margin: 10px auto 10px;
    }
  }
}
.tip_ {
  color: #333333;
  position: relative;
  .send_ {
    color: #017ceb;
    margin: 0 5px;
    position: absolute;
    font-size: 14px;
    top: 33%;
    right: 4px;
    z-index: 2;
  }
}
.cube-popup_mask {
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}
.popup_mask {
  display: inline-block;
  background: #fff;
  color: #000;
  padding: 14px;
  font-size: 12px;
}

.agreement-popup_box {
  width: 331px;
  border-radius: 7px;
  padding: 32px 26px 22px;
  background-color: #ffffff;
  font-size: 15px;
  color: #333333;
  h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  p {
    line-height: 25px;
  }
  .agreement-btn_box {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    .cube-btn {
      width: 100%;
      height: 40px;
      padding: 0;
      border-radius: 5px;
    }
    .btn_ {
      background: #ff7c6d;
      color: #ffffff;
    }
  }
}
</style>
